import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=5b596d09&lang=pug"
import script from "./activity-list.vue?vue&type=script&lang=js"
export * from "./activity-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports